<template>
  <button
    :class="['ot-base-button', buttonType, className, size]"
    :disabled="disabled"
    :style="{ width: width ? width : '' }"
    @click="onClick"
  >
    {{ text }}
  </button>
</template>

<script>
export default {
  name: "OTBaseButton",
  props: {
    text: {
      type: String,
      required: true,
    },
    buttonType: {
      type: String,
      default: "default",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
    },
    className: {
      type: String,
    },
    size: {
      type: String,
      default: "",
    },
  },
  methods: {
    onClick() {
      this.$emit("onClick");
    },
  },
};
</script>

<style lang="scss" scoped>
.ot-base-button {
  padding: 10px 77px;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
  border: 1px solid #000;
  background: #fff;
  color: #000;
  &.primary {
    background: #7f0019;
    color: #fff;
    border: 1px solid #7f0019;
  }

  &.default {
    color: #000;
    border: 1px solid #000;
  }

  &[disabled] {
    opacity: 0.2;
    cursor: not-allowed;
  }

  &.small {
    padding: 6px 20px;
    font-size: 12px;
  }
}

@media only screen and (max-width: 768px) {
  .ot-base-button {
    padding: 10px 18px;
    // margin: 0 5px;
  }
}
</style>
